import budgetsEdit from '@/views/budgets/edit'
import budgetsList from '@/views/budgets/list'

export default [
  {
    path: '/orcamentos',
    name: 'budgetsList',
    component: budgetsList,
    meta: {
      layout: 'sidebar',
      type: 'list',
      base: 'budgets',
      heading: 'menu.budgets',
      auth: true
    }
  },
  {
    path: '/orcamentos/novo',
    name: 'budgetsCreate',
    component: budgetsEdit,
    meta: {
      layout: 'sidebar',
      base: 'budgets',
      heading: 'menu.budgets',
      auth: true
    }
  },
  {
    path: '/orcamentos/:id/editar',
    name: 'budgetsUpdate',
    component: budgetsEdit,
    meta: {
      layout: 'sidebar',
      base: 'budgets',
      heading: 'menu.budgets',
      auth: true
    }
  },
]
